<template>
  <!-- Columna del Sidebar con ancho responsivo y altura completa -->
  <div class="col-auto col-sm-3 col-xl-2 px-sm-2 px-0 sidebar-bg sticky-top">
    <!-- Contenedor flex principal del sidebar, ocupa toda la altura. Mantenemos align-items-center para todas las vistas -->
    <div class="d-flex flex-column align-items-center px-3 pt-2 text-white min-vh-100">
      <!-- Logo: Remover me-md-auto, añadir w-100 y justify-content-center para centrar el contenido del flex item (la imagen) -->
      <a href="/" class="d-flex align-items-center justify-content-center w-100 pb-3 mb-md-0 text-white text-decoration-none">
        <img :src="isDarkMode ? require('@/assets/logo-nav-dark.webp') : require('@/assets/logo-nav.webp')"
             alt="Logo" class="img-fluid mt-3 sidebar-logo" />
      </a>

      <!-- Menú de Navegación: ocupa el espacio disponible. Ajustar align-items para que coincida con el contenedor principal -->
      <ul class="nav nav-pills flex-column mb-auto mt-3 align-items-center w-100" id="menu">
        <li class="nav-item w-100">
          <!-- Añadir title para tooltips en móvil -->
          <a class="nav-link d-flex align-items-center" @click="showHome" :class="{ selected: selectedItem === 'Home' }"
             href="#" title="Inicio">
            <span class="material-icons me-2">home</span>
            <span class="d-none d-sm-inline">Inicio</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click="showPacientes" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Pacientes' }" title="Pacientes">
            <span class="material-icons me-2">face</span>
            <span class="d-none d-sm-inline">Pacientes</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click="showMedicamentos" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Medicamentos' }" title="Herramientas">
            <span class="material-icons me-2">build</span>
            <span class="d-none d-sm-inline">Herramientas</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click="showMisPaquetes" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'MisPaquetes' }" title="Mis Paquetes">
            <span class="material-icons me-2">inventory</span>
            <span class="d-none d-sm-inline">Mis Paquetes</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click="showSettings" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Settings' }" title="Perfil">
            <span class="material-icons me-2">account_circle</span>
            <span class="d-none d-sm-inline">Perfil</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click="showReportes" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Reportes' }" title="Reportes">
            <span class="material-icons me-2">bar_chart</span>
            <span class="d-none d-sm-inline">Reportes</span>
          </a>
        </li>
      </ul>

      <!-- Dropdown Usuario: se alinea al final. Ajustar align-items para que coincida -->
      <div class="dropdown pb-4 pt-2 mt-auto w-100">
        <!-- Ajustar d-flex para centrar en móvil si es necesario, o mantener como está si el texto debe alinearse a la izquierda en desktop -->
        <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1"
           data-bs-toggle="dropdown" aria-expanded="false">
          <img :src="user.photoURL ? user.photoURL : require('@/assets/avatar.webp')" alt="Perfil" width="30" height="30"
               class="rounded-circle me-2 imagenBorde">
          <span class="d-none d-sm-inline smallText">{{ displayName }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
          <li>
            <a class="dropdown-item d-flex align-items-center" href="#" @click="logoutUser()">
              <span class="material-icons smallText me-1">power_settings_new</span>
              Cerrar Sesión
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import { auth } from "@/fb";
  export default {
    // Considerar renombrar el componente si el archivo se renombra a Sidebar.vue
    name: 'AppSidebar', // O mantener 'Footer' si prefieres no cambiar el nombre lógico
    data() {
      return {
        selectedItem: "Sidebar",
        user: [],
        isDarkMode: false
      };
    },
    computed: {
      ...mapState(["displayName"]),
    },
    created() {
      this.$eventBus.$on('lightModeChanged', (isLightMode) => {
        this.isDarkMode = !isLightMode;
      });

      auth.onAuthStateChanged((user) => {
        if (user) {
          this.user = user;
          this.updateDisplayName(user.displayName);
          this.$emit("displayNameChanged", user.displayName);
        } else {
          this.updateDisplayName("--");
          this.$emit("displayNameChanged", "--");
        }
      });

      this.$root.$on('userUpdated', this.handleUserUpdated);
      
    },
    beforeDestroy() {
      this.$eventBus.$off('lightModeChanged');
      this.$root.$off('userUpdated', this.handleUserUpdated);
    },
    watch: {
      $route(to, from) {
        this.selectedItem = to.name;
      },
    },
    methods: {
      ...mapActions(["updateDisplayName"]),
      logoutUser() {
        // Implementa el método de cierre de sesión
        localStorage.removeItem("user");
        this.$router.push("/");
        this.logout();
        location.reload();
      },
      callTiers() {
        console.log("click", this.$route.path);
        if (this.$route.path !== "/home") {
          this.selectedItem = "Tiers";
          this.$router.push({ name: "Home" });
          setTimeout(() => {
            this.$store.dispatch("callTiers");
          }, 1500);
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 2000);
        } else {
          this.selectedItem = "Tiers";
          this.$store.dispatch("callTiers");
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 1000);
        }
      },
      callAddons() {
        console.log("click", this.$route.path);
        if (this.$route.path !== "/home") {
          this.selectedItem = "Addons";
          this.$router.push({ name: "Home" });
          setTimeout(() => {
            this.$store.dispatch("callAddons");
          }, 1500);
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 2000);
        } else {
          this.selectedItem = "Addons";
          this.$store.dispatch("callAddons");
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 1000);
        }
      },
      showHome() {
        if (this.$route.path !== "/home") {
          this.$router.push({ name: "Home" });
          this.selectedItem = "Home";
        }
      },
      showUsers() {
        if (this.$route.path !== "/users") {
          this.$router.push({ name: "Users" });
          this.selectedItem = "Users";
        }
      },
      showFarms() {
        if (this.$route.path !== "/farms") {
          this.$router.push({ name: "Farms" });
          this.selectedItem = "Farms";
        }
      },
      showReportes() {
        if (this.$route.path !== "/reportes") {
          this.$router.push({ name: "Reportes" });
          this.selectedItem = "Reportes";
        }
      },
      showSettings() {
        if (this.$route.path !== "/settings") {
          this.$router.push({ name: "Settings" });
          this.selectedItem = "Settings";
        }
      },
      showPacientes() {
        if (this.$route.path !== "/pacientes") {
          this.$router.push({ name: "Pacientes" });
          this.selectedItem = "Pacientes";
        }
      },
      showMedicamentos() {
        if (this.$route.path !== "/medicamentos") {
          this.$router.push({ name: "Medicamentos" });
          this.selectedItem = "Medicamentos";
        }
      },
      showMisPaquetes() {
        if (this.$route.path !== "/paquetes") {
          this.$router.push({ name: "MisPaquetes" });
          this.selectedItem = "MisPaquetes";
        }
      },
      showLogs() {
        if (this.$route.path !== "/logs") {
          this.$router.push({ name: "Logs" });
          this.selectedItem = "Logs";
        }
      },
      showMessage() {
        this.notify("success", "Coming soon 🙌");
      },
      handleUserUpdated(updatedUser) {
        console.log('User updated:', updatedUser);
        // Realiza las acciones necesarias con el usuario actualizado
        this.user = { ...this.user, photoURL: null };
        setTimeout(() => {
          this.user = { ...this.user, photoURL: `${updatedUser.photoURL}` };
        }, 1000);
        this.user = updatedUser;
      },
    },
  };
</script>

<style scoped>
  /* Estilos base del Sidebar */
  .sidebar-bg {
    /* Define tu color de fondo aquí */
    background-color: #212529; /* Ejemplo dark */
    background: linear-gradient(178deg, #212529, transparent);
  }

  body.light-mode .sidebar-bg {
     background-color: #d5fff6; /* Ejemplo light */
     box-shadow: 1px 0px 6px #afafaf;
     background: linear-gradient(360deg, #d5fff6, transparent);
  }

  .sidebar-logo {
    max-width: 150px; /* Ajusta según necesidad */
    height: auto;
  }

  /* Estilos base para los enlaces de navegación */
  .nav-link {
    color: rgba(255, 255, 255, 0.7); /* Color de texto base para tema oscuro */
    padding: 0.75rem 1rem; /* Ajustar padding */
    margin-bottom: 0.25rem; /* Espacio entre elementos */
    border-radius: 0.375rem; /* Bootstrap default border-radius */
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
    text-decoration: none;
  }

  body.light-mode .nav-link {
     color: #333333 /* Color de texto base para tema claro */
  }

  /* Estilo Hover */
  .nav-link:hover {
    color: #ffffff; /* Texto más brillante en hover (dark) */
    background-color: rgba(255, 255, 255, 0.1); /* Fondo sutil en hover (dark) */
  }

  body.light-mode .nav-link:hover {
     color: #333333; /* Texto más oscuro en hover (light) */
     background-color: rgba(0, 0, 0, 0.05); /* Fondo sutil en hover (light) */
  }

  /* Estilo Seleccionado */
  .nav-link.selected {
    color: #ffffff; /* Texto blanco para seleccionado (dark) */
    /* Usa un color de fondo que contraste bien */
    background-color: #00eebd63; /* Ejemplo: Azul Bootstrap */
    font-weight: 500; /* Opcional: un poco más de énfasis */
  }

   body.light-mode .nav-link.selected {
     color: #ffffff; /* Texto blanco para seleccionado (light) */
     background-color: #00eebd63; /* Mismo azul o uno adecuado para light mode */
   }

  /* Iconos */
  .nav-link .material-icons {
    /* El gradiente se aplica directamente en el span ahora */
    /* text-main-gradient puede necesitar ajustes o ser removido si el color lo maneja el estado */
    vertical-align: middle;
  }

  /* Ajustes responsivos si son necesarios */
  @media (max-width: 575.98px) {
    .sidebar-logo {
      max-width: 40px; /* Logo más pequeño en móvil */
      margin-top: 0.5rem !important;
      margin-bottom: 0.5rem !important;
    }
    .nav-link span.d-none.d-sm-inline {
      display: none !important; /* Asegura que el texto se oculte */
    }
    .nav-link .material-icons {
      margin-right: 0 !important; /* Sin margen si no hay texto */
      font-size: 1.5rem; /* Iconos un poco más grandes */
    }
     .nav-link {
        padding: 0.5rem; /* Padding más ajustado */
        text-align: center;
     }
     #menu {
        margin-top: 1rem !important;
     }
  }

  /* Estilo del borde de la imagen de perfil */
  .imagenBorde {
    border: 2px solid #15e35c; /* Mantenido de tu estilo original */
  }

  /* Asegurar que el texto del dropdown sea legible */
  .dropdown-menu {
    /* background-color: #343a40; */ /* Fondo oscuro para dropdown */
  }
  body.light-mode .dropdown-menu {
     /* background-color: #ffffff; */ /* Fondo claro para dropdown */
     /* border: 1px solid #dee2e6; */
  }
  .dropdown-item {
    /* color: rgba(255, 255, 255, 0.7); */
  }
  .dropdown-item:hover {
    /* background-color: rgba(255, 255, 255, 0.1); */
    /* color: #ffffff; */
  }
   body.light-mode .dropdown-item {
     /* color: #212529; */
   }
   body.light-mode .dropdown-item:hover {
     /* background-color: #e9ecef; */
     /* color: #000; */
   }

</style>